export function environment(environment) {
    const listeners = [];
    const userListeners = [];
    const triggerListeners = (...params) => {
        listeners.forEach((listener) => {
            listener.bind(null)(...params);
        });
    };
    const triggerUserListeners = (user) => {
        userListeners.forEach((listener) => {
            listener(user);
        });
    };
    return {
        getEnvironment: () => environment,
        setUniverse: (universe) => {
            environment.setUniverse(universe);
            triggerListeners(environment.getUniverse());
        },
        setApplication: (applicationId) => {
            environment.setApplicationName(applicationId);
            triggerListeners(environment.setUniverseFromApplicationId(applicationId));
        },
        onUniverseChange: (callback) => {
            listeners.push(callback);
        },
        onUserChange: (callback) => {
            userListeners.push(callback);
        },
        setUser: (user) => {
            const updatedUser = Object.assign(Object.assign({}, environment.user), user);
            environment.setUser(updatedUser);
            triggerUserListeners(updatedUser);
        },
    };
}
export default environment;
//# sourceMappingURL=index.js.map